<template>
  <v-toolbar class="primary elevation-0 small-extension" dark>
    <h1 class="titulo">{{ apelido }}</h1>
    <div v-if="proprietario || tipo || savoyNetItems.length > 0" slot="extension" class="detalhes-toolbar-extension">
      <span v-if="tipo" style="margin: 0 18px;"><span class="caption secondary--text" style="font-weight: 500 !important;">Tipo</span> {{ tipo }}</span>
      <span v-if="proprietario"><span class="caption secondary--text" style="font-weight: 500 !important;">Proprietário</span> {{ proprietario }}</span>
      <span v-if="savoyNetItems.length === 1" style="margin-left: 18px;">
        <span class="caption secondary--text" style="font-weight: 500 !important;">SavoyNet</span>
        <a
          :href="savoyNetItems[0].url"
          target="_blank"
          rel="noopener noreferrer"
          class="white--text"
        >
          {{ savoyNetItems[0].numero }}
        </a>
      </span>
      <v-menu v-if="savoyNetItems.length > 1" offset-y>
        <v-btn slot="activator" flat class="ma-0 savoynet-ativador">
          <span class="caption secondary--text" style="font-weight: 500 !important;">SavoyNet</span>
          <span class="white--text" style="margin-left: 4px;">({{ savoyNetItems.length }})</span>
        </v-btn>
        <v-card>
          <v-list>
            <v-list-tile
              v-for="item in savoyNetItems"
              :key="item.numero"
              :href="item.url"
              target="_blank"
              rel="noopener noreferrer"
            >
              <v-list-tile-title>{{ item.numero }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>
    </div>
  </v-toolbar>
</template>

<script>
  import { buildSavoyNetUrl, parseSavoyNetFromApi } from '@/utils/savoynet'

  export default {
    props: [
      'apelido',
      'proprietario',
      'tipo',
      'savoynet'
    ],
    computed: {
      savoyNetItems () {
        return parseSavoyNetFromApi(this.savoynet).map((numero) => {
          return {
            numero,
            url: buildSavoyNetUrl(numero)
          }
        })
      }
    },
    methods: {
      setRightNav () {
        this.$store.dispatch('template/setRightNav', true)
      }
    }
  }
</script>

<style scoped>
  .detalhes-toolbar-extension {
    width: 100%;
    text-align: center;
  }

  .savoynet-ativador {
    min-width: 0;
    margin-left: 12px !important;
  }
</style>



// WEBPACK FOOTER //
// HeadersDetalhesResumo.vue?4e40270a